import { EventEmitter } from "@angular/core";
import { ButtonsActionsTableComponent } from "@app/shared";

export class ConsecutiveManagementConfigService{
  // Se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // Se emite cada vez que se realiza una accion con los botones de la tabla de la modal
  accionModal: EventEmitter<any> = new EventEmitter();
  // Contiene la configuracion de la tabla
  settings = {};
  // Contiene la configuracion de la modal
  settingsModal = {};

  constructor(){
    const self = this;
    this.settings = {
      mode: 'external',
      actions: false,
      noDataMessage: 'No hay resultados',
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        id: {
          editable: false,
          addable: false,
          title: 'Id',
          class: 'prueba',
          filter: {
            inputClass: 'form-control',
          },
        },
        // Se setea nueva columna
        dependencia: {
          editable: false,
          addable: false,
          title: 'Dependencia',
          class: 'prueba',
          filter: {
            inputClass: 'form-control',
          },
          valuePrepareFunction: (cell: any, row: any) => {
            if (row.dependencia) {
              return row.dependencia.dependencia;
            } else {
              return null;
            }
          },
          filterFunction: (cell?: any, search?: string) => {
            if (cell.dependencia){
              return cell.dependencia.toLowerCase().includes(search.toLowerCase()) ? true : false;
            }else{
              return false;
            }
          }
        },
        consecutivo: {
          editable: false,
          addable: false,
          title: 'Consecutivo',
          class: 'prueba',
          filter: {
            inputClass: 'form-control',
          },
        },
        periodicidad: {
          editable: false,
          addable: false,
          title: 'Periodo',
          class: 'prueba',
          filter: {
            inputClass: 'form-control',
          },
        },
        tipo_periodicidad: {
          editable: false,
          addable: false,
          title: 'Tipo de periodicidad',
          class: 'prueba',
        },
        fecha_reinicio: {
          editable: false,
          addable: false,
          title: 'Fecha de último reinicio',
          class: 'prueba',
        },
        button: {
          title: 'Acciones',
          filter: false,
          sort: false,
          type: 'custom',
          renderComponent: ButtonsActionsTableComponent,
          onComponentInitFunction(instance: any) {
            instance.save.subscribe((data: any) => {
              // Controla el evento click del boton
              self.accion.emit(data);
            });
          }
        },
      },
    };
    this.settingsModal = {
      mode: 'external',
      actions: false,
      noDataMessage: 'No hay resultados',
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        serie: {
          editable: false,
          addable: false,
          title: 'Serie',
          class: 'prueba',
          filter: {
            inputClass: 'form-control',
          },
        },
        subserie: {
          editable: false,
          addable: false,
          title: 'Subserie',
          class: 'prueba',
          filter: {
            inputClass: 'form-control',
          },
        },
        tipo_documental: {
          editable: false,
          addable: false,
          title: 'Tipo documental',
          class: 'prueba',
          filter: {
            inputClass: 'form-control',
          },
        },
        button: {
          title: 'Acciones',
          filter: false,
          sort: false,
          type: 'custom',
          renderComponent: ButtonsActionsTableComponent,
          onComponentInitFunction(instance: any) {
            instance.save.subscribe((data: any) => {
              // Controla el evento click del boton
              self.accionModal.emit(data);
            });
          }
        },
      },
    };
  }
}


// WEBPACK FOOTER //
// ./src/app/administration/documents/consecutive-management/shared/consecutive-management-config.service.ts